'use strict';
var React = require('react');
var BallSize = 80;
var HalfBallSize = 40;
var _ = require('underscore');
var storeHelper = require('../helper/storeHelper');
var assetsHelper = require('../helper/assetsHelper');

var ControlBall = React.createClass({
  propTypes: {
    onTogglePanel: React.PropTypes.func.isRequired,
    domSize: React.PropTypes.shape({
      width: React.PropTypes.number.isRequired,
      height: React.PropTypes.number.isRequried
    }).isRequired
  },
  getInitialState: function () {
    var store = storeHelper.get('ball_position');
    var domSize;
    if (store) {
      return this.fitBallPosition(JSON.parse(store));
    }
    domSize = this.props.domSize;
    return {
      left: domSize.width - HalfBallSize,
      top: domSize.height/2 - BallSize,
      edge: true
    };
  },
  render: function () {
    var style;
    var className = 'control-ball';
    style = {
      left: this.state.left,
      top: this.state.top
    };
    if (this.state.finishing) {
      className += ' finishing';
    }
    if (this.state.edge) {
      className += ' edge';
    }
    return (
      <div className={className}
           style={style}
           // onClick={this.props.onTogglePanel}
           onTouchStart={this.onTouchStart}
           onTouchMove={this.onTouchMove}
           onTouchEnd={this.onTouchEnd}>
        <img src={assetsHelper.getAsset('m.png')}/>
      </div>
    );
  },
  onTouchStart: function (e) {
    var touch = e.touches[0];
    this.start = {
      left: touch.pageX - HalfBallSize,
      top: touch.pageY - HalfBallSize
    };
    this.moving = false;
    e.stopPropagation();
    e.preventDefault();
  },
  onTouchMove: function (e) {
    var touch = e.touches[0];
    var newPosition = {
      left: touch.pageX - HalfBallSize,
      top: Math.min(Math.max(touch.pageY - HalfBallSize, 0), this.props.domSize.height - BallSize)
    };
    if (Math.max(Math.abs(newPosition.left - this.start.left), Math.abs(newPosition.top - this.start.top)) > 10) {
      this.moving = true;
      newPosition.isMoved = true;
      newPosition.moved = true;
      this.setState(newPosition);
    }
    e.stopPropagation();
    e.preventDefault();
  },
  onTouchEnd: function (e) {
    if (!this.moving) {
      this.props.onTogglePanel();
      return;
    }
    var self = this;
    var width = this.props.domSize.width;
    var height = this.props.domSize.height;
    var top = this.state.top;
    var left = this.state.left;
    var bottom = height - top - BallSize;
    var right = width - left - BallSize;
    var toTop = 0;
    var toLeft = 0;
    var newPosition;

    var centerLeft = left + HalfBallSize;

    if (centerLeft > width / 4 && centerLeft < width * 3 / 4) {
      this.setState({
        edge: false
      }, function () {
        storeHelper.set('ball_position', JSON.stringify({
          left: this.state.left,
          top: this.state.top,
          edge: false
        }));
      });
      return;
    }

    if (centerLeft <= width / 4) {
      toLeft = -HalfBallSize;
    } else {
      toLeft = this.props.domSize.width - HalfBallSize;
    }

    newPosition = this.fitBallPosition({
      left: toLeft,
      top: top
    });
    this.setState({
      finishing: true,
      edge: true,
      left: newPosition.left,
      top: newPosition.top
    }, function () {
      setTimeout(function () {
        storeHelper.set('ball_position', JSON.stringify({
          left: newPosition.left,
          top: newPosition.top,
          edge: true
        }));
        self.setState({
          finishing: false
        });
      }, 200);
    });
    e.stopPropagation();
    e.preventDefault();
  },
  fitBallPosition: function (position) {
    var domSize = this.props.domSize;
    return {
      left: Math.min(position.left, domSize.width - HalfBallSize),
      top: Math.min(position.top, domSize.height - HalfBallSize),
      edge: position.edge
    };
  }
});

module.exports = ControlBall;



// WEBPACK FOOTER //
// ./src/views/ControlBall.jsx